export default [
  { title: "Rules and resource limits", icon: "", link: "/docs/concepts/rules-and-limits/" },
  { title: "Formatting API requests", icon: "", link: "/docs/concepts/rules-and-limits/requests/" },
  { title: "Handling API responses", icon: "", link: "/docs/concepts/rules-and-limits/responses/" },
];
